import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function QuemSomos() {
  return (
    <div className="min-h-screen bg-white font-['Inter']">
      <Navbar />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-[#CB9832]/5 via-white to-[#CB9832]/5">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <nav className="text-sm text-gray-600 mb-6">
            <a href="/" className="hover:text-[#CB9832] cursor-pointer">Início</a>
            <span className="mx-2">&gt;</span>
            <span className="text-[#CB9832]">Quem Somos</span>
          </nav>
          <h1 className="text-53xl md:text-5xl font-bold text-black mb-6">QUEM SOMOS</h1>
          <div className="max-w-4xl mx-auto space-y-6">
            <p className="text-base md:text-lg text-gray-700 leading-relaxed font-medium">
              A +KUDIMA é mais do que uma empresa de consultoria: é uma plataforma estratégica dedicada à transformação sustentável de organizações, sectores e ecossistemas. Actuamos como agentes de mudança, desenvolvendo soluções que integram sustentabilidade, inovação e impacto real.
            </p>
            <p className="text-base md:text-lg text-gray-600 leading-relaxed">
              Nascemos com o propósito de <strong className="text-[#CB9832]">criar, gerir e comunicar</strong>.
            </p>
            <p className="text-lg md:text-xl text-gray-600 leading-relaxed">
              O nosso nome vem do desejo de <strong className="text-black">"fazer mais"</strong> — mais inovação, mais responsabilidade, mais futuro.
            </p>
            <p className="text-base md:text-lg text-gray-600 leading-relaxed max-w-3xl mx-auto">
              A nossa actuação assenta na convicção de que a sustentabilidade deve ser incorporada na estratégia, nos processos e na cultura organizacional, gerando valor económico, social e ambiental de forma consistente e mensurável.
            </p>
          </div>
        </div>
      </section>

      {/* Nossa Missão e Visão */}
      <section id="missao" className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-black mb-4">Nossa Essência</h2>
            <p className="text-lg text-gray-600">Os princípios que orientam a nossa actuação e sustentam cada projecto desenvolvido.</p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {/* Missão */}
            <div className="bg-gradient-to-br from-[#CB9832]/5 to-white rounded-3xl p-5 hover:shadow-xl transition-all">
              <div className="w-20 h-20 flex items-center justify-center bg-[#2D5F3F] rounded-2xl mb-6">
                <i className="ri-compass-3-line text-2xl text-white"></i>
              </div>
              <h3 className="text-lg font-bold text-black mb-4">Nossa Missão</h3>
              <p className="text-gray-700 text-lg leading-relaxed">
                Promover soluções estratégicas em sustentabilidade que apoiem organizações na criação de valor a longo prazo, fortalecendo a competitividade, a inovação e o impacto positivo.
              </p>
            </div>

            {/* Visão */}
            <div className="bg-gradient-to-br from-[#2D5F3F]/5 to-white rounded-3xl p-5 hover:shadow-xl transition-all">
              <div className="w-20 h-20 flex items-center justify-center bg-[#2D5F3F] rounded-2xl mb-6">
                <i className="ri-eye-line text-2xl text-white"></i>
              </div>
              <h3 className="text-lg font-bold text-black mb-4">Nossa Visão</h3>
              <p className="text-gray-700 text-lg leading-relaxed">
                Contribuir para uma ecossistema mais inclusivo, competitivo e preparado para os desafios globais.
              </p>
            </div>
          </div>
        
          {/* Propósito */}
          <div className="mt-8 bg-white rounded-3xl p-10 shadow-lg border-2 border-[#CB9832]/20">
            <div className="flex items-start gap-6">
              <div className="w-20 h-20 flex items-center justify-center bg-[#2D5F3F]/10 rounded-2xl flex-shrink-0">
                <i className="ri-heart-pulse-line text-4xl text-[#2D5F3F]"></i>
              </div>
              <div>
                <h3 className="text-lg font-bold text-black mb-4">Nosso Propósito</h3>
                <p className="text-gray-700 text-lg leading-relaxed">
                  Impulsionar a transição para modelos de desenvolvimento sustentável, integrando conhecimento técnico, estratégia e execução, para gerar impacto real, mensurável e duradouro.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Nossa Abordagem */}
      <section className="py-24 bg-[#F8F8F8]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-2xl md:text-5xl font-bold text-black mb-4">Como Trabalhamos</h2>
            <p className="text-lg text-gray-600">Uma metodologia integrada, orientada para resultados sustentáveis.</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              {
                number: '01',
                icon: 'ri-search-eye-line',
                title: 'Diagnóstico',
                description: 'Analisamos o contexto organizacional, identificando riscos, oportunidades e prioridades estratégicas, com base em dados, boas práticas e enquadramento sectorial.',
                image: 'https://readdy.ai/api/search-image?query=professional%20black%20african%20business%20consultant%20analyzing%20sustainability%20data%20documents%20charts%20modern%20office%20bright%20natural%20lighting%20confident%20expertise%20environmental%20assessment&width=400&height=300&seq=approach-black-001&orientation=landscape',
              },
              {
                number: '02',
                icon: 'ri-lightbulb-flash-line',
                title: 'Estratégia',
                description: 'Desenvolvemos soluções estratégicas personalizadas, alinhadas aos objectivos institucionais, às exigências regulatórias e às expectativas das partes interessadas.',
                image: './post/img5.jpg',
              },
              {
                number: '03',
                icon: 'ri-tools-line',
                title: 'Implementação',
                description: 'Apoiamos a execução das soluções propostas, assegurando coerência entre planeamento, acção e monitorização de resultados.',
                image: './post/img4.jpg',
              },
              {
                number: '04',
                icon: 'ri-line-chart-line',
                title: 'Resultados',
                description: 'Medimos impacto, avaliamos desempenho e ajustamos estratégias, garantindo valor sustentável e melhoria contínua.',
                image: './post/img6.jpg',
              },
            ].map((step, index) => (
              <div key={index} className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all group">
                <div className="w-full h-48 overflow-hidden">
                  <img src={step.image} alt={step.title} className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform" />
                </div>
                <div className="p-6">
                  <div className="flex items-center gap-3 mb-4">
                    <span className="text-4xl font-bold text-[#CB9832]/20">{step.number}</span>
                    <div className="w-12 h-12 flex items-center justify-center bg-[#CB9832]/10 rounded-lg">
                      <i className={`${step.icon} text-2xl text-[#CB9832]`}></i>
                    </div>
                  </div>
                  <h3 className="text-xl font-bold text-black mb-3">{step.title}</h3>
                  <p className="text-gray-600 leading-relaxed text-sm">{step.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Valores Section */}
      <section id="valores" className="py-24 bg-[#F8F8F8]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-black mb-4">NOSSOS VALORES</h2>
            <p className="text-lg text-gray-600">Os princípios que guiam nossa actuação.</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {[
              {
                icon: 'ri-shield-star-line',
                title: 'Excelência',
                description:
                  'Actuamos com rigor técnico, profissionalismo e foco na qualidade, assegurando soluções robustas e alinhadas às melhores práticas.',
              },
              {
                icon: 'ri-lightbulb-flash-line',
                title: 'Inovação',
                description:
                  'Promovemos abordagens criativas e soluções inovadoras, adaptadas aos desafios actuais e às necessidades emergentes do mercado.',
              },
              {
                icon: 'ri-team-line',
                title: 'Colaboração',
                description:
                  'Valorizamos o trabalho em equipa, a co-criação e a construção de parcerias estratégicas que geram valor mútuo e impacto sustentável.',
              },
              {
                icon: 'ri-heart-pulse-line',
                title: 'Compromisso Social',
                description:
                  'Actuamos com responsabilidade social, contribuindo para o desenvolvimento sustentável das comunidades e organizações com as quais trabalhamos.',
              },
            ].map((value, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl p-4 hover:shadow-xl transition-all group cursor-pointer"
              >
                <div className="w-16 h-16 mb-6 flex items-center justify-center bg-[#2D5F3F] rounded-full group-hover:scale-110 transition-transform">
                  <i className={`${value.icon} text-3xl text-white`}></i>
                </div>
                <h3 className="text-lg font-bold text-black mb-4">{value.title}</h3>
                <p className="text-gray-600 leading-relaxed">{value.description}</p>
              </div>  
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-[#CB9832] to-[#B8872D]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">Vamos Trabalhar Juntos?</h2>
          <p className="text-lg mb-8 leading-relaxed">
            Entre em contacto connosco e descubra como a +KUDIMA pode apoiar a sua organização na implementação de soluções estratégicas com impacto mensurável.
          </p>
          <a
            href="/contato"
            className="inline-flex items-center bg-white text-[#CB9832] px-8 py-4 rounded-full font-semibold text-lg hover:bg-gray-100 transition-all shadow-xl whitespace-nowrap cursor-pointer"
          >
            Falar com Especialista
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}
